var _style, _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 342.1 342.1",
    style: {
      enableBackground: "new 0 0 342.1 342.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#003554;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#00FFBC;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.3,0.2h239.4c28.3,0,51.3,23,51.3,51.3v239.4c0,28.3-23,51.3-51.3,51.3H51.3C23,342.2,0,319.2,0,290.9V51.5 C0,23.2,23,0.2,51.3,0.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M138.5,181.7c-4.7,13.4-17.5,23-32.5,23c-19,0-34.5-15.5-34.5-34.5c0-19,15.5-34.5,34.5-34.5 c14.5,0,26.9,9,32,21.7l21.3-8.6c-8.5-21.2-29.2-36.1-53.3-36.1c-31.7,0-57.5,25.7-57.5,57.5c0,31.7,25.7,57.5,57.5,57.5 c27.8,0,51-19.7,56.3-46H138.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.6,141.5c-6.3,0-11.5,5.1-11.5,11.5s5.1,11.5,11.5,11.5c6.3,0,11.5-5.1,11.5-11.5S155,141.5,148.6,141.5 L148.6,141.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 157.3,
    y: 160,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 504.6065 122.6587)",
    className: "st1",
    width: 139.3,
    height: 11.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.5,
    y: 168.2,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 524.4222 130.8667)",
    className: "st1",
    width: 139.3,
    height: 11.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.5,
    y: 160,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 284.0898 449.3478)",
    className: "st1",
    width: 139.3,
    height: 11.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.3,
    y: 168.2,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 264.2741 457.5557)",
    className: "st1",
    width: 139.3,
    height: 11.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.5a91ac57c1a46c353a438bdb0909cd12.svg";
export { ForwardRef as ReactComponent };